module.exports = "/img/pc_apply.png?b07c46df91008910ec7a456575b4505a";